import { getHashParameters as a, buildHashParameters as d, getSiteAccess as g } from "@imaios-js/utils";
function h(e, t) {
  const n = new URL(window.location.href), c = a(window.location.href);
  c.set(e, t), n.hash = d(c), window.history.replaceState(window.history.state, "", n);
}
function m(e) {
  const t = new URL(window.location.href), n = a(window.location.href);
  n.delete(e), t.hash = d(n), window.history.replaceState(window.history.state, "", t);
}
function u(e) {
  try {
    return a(window.location.href).has(e);
  } catch {
    return !1;
  }
}
function l(e) {
  try {
    return u(e) ? a(window.location.href).get(e) ?? null : null;
  } catch {
    return null;
  }
}
function f() {
  document.getElementById("definition-content-block").classList.add("d-none");
}
function I() {
  document.getElementById("definition-content-block").classList.remove("d-none");
}
function S() {
  document.getElementById("structure-add-definition-container").classList.add("d-none"), document.getElementById("structure-headerDefinition").classList.remove("d-none"), document.getElementById("structure-definitionText").classList.remove("d-none"), document.getElementById("structure-sourceText").classList.remove("d-none");
}
const i = "description", r = "edit_hash", o = localStorage.getItem(r) ?? l(i);
localStorage.removeItem(r);
async function w(e) {
  const { createForm: t } = await import("./main-vue-BRXLXKSc.js");
  h(i, e), await t(e), f();
}
async function y() {
  return await window.loginManagementService.awaitConnection(), window.loginManagementService.isConnected() && window.languageSwitcher.getHashFromSelectedLanguage() !== "";
}
function L() {
  const e = window.languageSwitcher.getHashFromSelectedLanguage(), t = o === e;
  return window.loginManagementService.isConnected() && o !== null && t;
}
async function s(e = !1, t = window.languageSwitcher.getHashFromSelectedLanguage()) {
  if (await y()) {
    await w(t);
    return;
  }
  e && (localStorage.setItem(r, t), window.location.href = `/${g()}/login`);
}
function E() {
  document.getElementById("structure-definitionEdition")?.addEventListener("click", async () => await s(!0)), document.getElementById("structure-add-definition")?.addEventListener("click", async () => (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    await s(!0, window.getFromImaiosStore("currentHash"))
  )), document.querySelectorAll(".structure-def-languages").forEach((e) => {
    e.addEventListener("click", async () => {
      const t = e.getAttribute("data-attr-hash");
      await window.languageSwitcher.changeDefinitionFromHash(t), window.languageSwitcher.selectLanguageFromHash(t), S();
    });
  });
}
async function v() {
  if (await window.loginManagementService.awaitConnection(), !window.loginManagementService.isConnected()) {
    m(i);
    return;
  }
  if (u(i) || L()) {
    const e = l(i) ?? o;
    if (e === null)
      return;
    window.languageSwitcher.selectLanguageFromHash(e), await window.languageSwitcher.changeDefinitionFromHash(e), await w(e);
  }
}
v();
E();
export {
  v as a,
  i as e,
  E as i,
  I as s,
  m as u
};
//# sourceMappingURL=index-DEofchW3.js.map
